export interface NavigationState {
	current: string;
	flow: Flow;
	previous?: string;
}

export const navigationActions = {
	saveStep: '@navigationStep/saveStep',
};

export type Flow = 'subscription' | 'integratedSolution' | 'noFlow';
